import { render, staticRenderFns } from "./wirte-answer.vue?vue&type=template&id=22e91b68&scoped=true&"
import script from "./wirte-answer.vue?vue&type=script&lang=js&"
export * from "./wirte-answer.vue?vue&type=script&lang=js&"
import style0 from "./wirte-answer.vue?vue&type=style&index=0&id=22e91b68&lang=scss&scoped=true&"
import style1 from "./wirte-answer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e91b68",
  null
  
)

export default component.exports